import { useEffect } from 'react'
import { OrderFeedbackModal } from '#features/order-feedback'
import { OrderStatusUpdatedEventPayload, parseNumericOrderStatus } from '#entities/order'
import { wsClient } from '#shared/api'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'
import { showModal } from '#shared/lib/modals'

interface ModalsDispatcherProps {
  children: React.ReactNode
}

export default function ModalsDispatcher({ children }: ModalsDispatcherProps) {
  useEffect(() => {
    const roleInfo = getCurrentUserRoleInfo()

    const onOrderStatusUpdated = async (payload: OrderStatusUpdatedEventPayload) => {
      const orderId = payload.eventBody.orderId
      const status = parseNumericOrderStatus(payload.eventBody.status)

      await new Promise(resolve => setTimeout(resolve, 5000))

      if (status === 'CANCELLED' && roleInfo.role === 'staff') {
        showModal(closeSignal => <OrderFeedbackModal isOpen orderId={orderId} onClose={closeSignal.trigger} />)
      }

      if (status === 'FINISHED') {
        showModal(closeSignal => <OrderFeedbackModal isOpen orderId={orderId} onClose={closeSignal.trigger} />)
      }
    }

    wsClient.on('order-status-updated-v1', onOrderStatusUpdated)

    return () => wsClient.off('order-status-updated-v1', onOrderStatusUpdated)
  })

  return children
}
